import React from "react";
import "./Footer.css";

const CopyRight = () => {
  return (
    <div className="footerBottom px-5 py-3" id="footer">
      <p className="text-center w-100 text-light mb-1">
        © Copyright <span className=" fw-500">Aditya BN & Co</span>. All Rights
        Reserved
      </p>
      <p className="text-center w-100 text-light  mb-0">
        Designed by
        <span
          style={{ color: "var(--buttonBackground)" }}
          className="cursor-pointer"
        >
          {" "}
          Koyo Software Solutions
        </span>
      </p>
    </div>
  );
};

export default CopyRight;
